import { useUserInfo } from 'marketing-platform-lib/providers/UserInfoProvider';

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/selectors/Scope.ts#L86
 */
export default function useShouldRenderFormsNextV2() {
  const {
    hasScope
  } = useUserInfo();
  return hasScope('forms-v2-temp') && !hasScope('forms-dependent-fields-access');
}